import * as React from "react";
import Cards from "./Cards";
import { WebsocketContext } from "./WebsocketProvider";
import LabeledPlay from "./LabeledPlay";
import { useEngine } from "./useEngine";
import { useTranslation } from "./i18n";
var BidArea = function (props) {
    var _a, _b;
    var send = React.useContext(WebsocketContext).send;
    var engine = useEngine();
    var t = useTranslation().t;
    var _c = React.useState([]), validBids = _c[0], setValidBids = _c[1];
    var _d = React.useState(false), isLoadingBids = _d[0], setIsLoadingBids = _d[1];
    var trump = props.trump == null ? { NoTrump: {} } : props.trump;
    var markDoneBidding = function (evt, ready) {
        evt.preventDefault();
        send({ Action: { MarkBiddingDone: { ready: ready } } });
    };
    var players = {};
    var playerId = -1;
    props.players.forEach(function (p) {
        players[p.id] = p;
        if (p.name === props.name) {
            playerId = p.id;
        }
    });
    // Load valid bids when player is not a spectator
    React.useEffect(function () {
        if (playerId >= 0) {
            setIsLoadingBids(true);
            engine
                .findValidBids({
                id: playerId,
                bids: props.bids,
                hands: props.hands,
                players: props.players,
                landlord: props.landlord,
                epoch: props.epoch,
                bid_policy: props.bidPolicy,
                bid_reinforcement_policy: props.bidReinforcementPolicy,
                joker_bid_policy: props.jokerBidPolicy,
                num_decks: props.numDecks,
            })
                .then(function (bids) {
                // Sort the bids
                bids.sort(function (a, b) {
                    if (a.card < b.card) {
                        return -1;
                    }
                    else if (a.card > b.card) {
                        return 1;
                    }
                    else if (a.count < b.count) {
                        return -1;
                    }
                    else if (a.count > b.count) {
                        return 1;
                    }
                    else {
                        return 0;
                    }
                });
                setValidBids(bids);
                setIsLoadingBids(false);
            })
                .catch(function (error) {
                console.error("Error finding valid bids:", error);
                setValidBids([]);
                setIsLoadingBids(false);
            });
        }
    }, [
        playerId,
        props.bids,
        props.hands,
        props.players,
        props.landlord,
        props.epoch,
        props.bidPolicy,
        props.bidReinforcementPolicy,
        props.jokerBidPolicy,
        props.numDecks,
        engine,
    ]);
    if (playerId === null || playerId < 0) {
        // Spectator mode
        return (React.createElement("div", null,
            props.header,
            props.autobid !== null ? (React.createElement(LabeledPlay, { label: "".concat(players[props.autobid.id].name, " ").concat(t("bid.fromBottom")), trump: trump, cards: [props.autobid.card] })) : null,
            props.bids.map(function (bid, idx) {
                var name = players[bid.id].name;
                return (React.createElement(LabeledPlay, { label: name, key: idx, trump: trump, cards: Array(bid.count).fill(bid.card) }));
            }),
            props.bids.length === 0 && props.autobid === null ? (React.createElement(LabeledPlay, { trump: trump, label: t("bid.noBidsYet"), cards: ["🂠"] })) : null));
    }
    else {
        var levelId = props.landlord !== null && props.landlord !== undefined
            ? props.landlord
            : playerId;
        var trump_1 = props.trump !== null && props.trump !== undefined
            ? props.trump
            : {
                NoTrump: {
                    number: players[levelId].level !== "NT" ? players[levelId].level : null,
                },
            };
        return (React.createElement("div", null,
            React.createElement("div", null,
                props.header,
                props.autobid !== null ? (React.createElement(LabeledPlay, { label: "".concat(players[props.autobid.id].name, " ").concat(t("bid.fromBottom")), cards: [props.autobid.card], trump: trump_1 })) : null,
                props.bids.map(function (bid, idx) {
                    var name = players[bid.id].name;
                    return (React.createElement(LabeledPlay, { label: name, key: idx, trump: trump_1, cards: Array(bid.count).fill(bid.card) }));
                }),
                props.trump !== undefined &&
                    "NoTrump" in props.trump &&
                    ((_b = (_a = props.trump) === null || _a === void 0 ? void 0 : _a.NoTrump) === null || _b === void 0 ? void 0 : _b.number) === null ? (React.createElement(React.Fragment, null, t("bid.noBidsInNoTrump"))) : props.bids.length === 0 && props.autobid === null ? (React.createElement(LabeledPlay, { trump: trump_1, label: t("bid.noBidsYet"), cards: ["🂠"] })) : null),
            React.createElement("div", { className: "my-3 flex flex-wrap items-center gap-2" },
                props.prefixButtons,
                props.suffixButtons),
            props.showDoneBidding ? (props.isDoneBidding ? (React.createElement("div", { className: "my-3 flex flex-wrap items-center gap-2" },
                React.createElement("button", { onClick: function (evt) { return markDoneBidding(evt, false); }, className: "sj-btn" }, t("bid.undoDoneBidding")),
                React.createElement("span", { className: "text-sm font-medium text-[var(--text-on-felt-soft)]" }, t("bid.waitingForOthers")))) : (React.createElement("div", { className: "my-3 flex flex-wrap items-center gap-2" },
                React.createElement("button", { onClick: function (evt) { return markDoneBidding(evt, true); }, className: "sj-btn sj-btn-primary" }, t("bid.doneBidding")),
                React.createElement("span", { className: "text-sm font-medium text-[var(--text-on-felt)]" }, t("bid.yourMovePrompt"))))) : null,
            React.createElement("p", { className: "mb-1 text-sm font-semibold text-[var(--text-on-felt)]" }, isLoadingBids
                ? t("bid.loading")
                : validBids.length > 0
                    ? t("bid.clickToBid")
                    : t("bid.noAvailable")),
            !isLoadingBids &&
                validBids.map(function (bid, idx) {
                    return (React.createElement(LabeledPlay, { trump: trump_1, cards: Array(bid.count).fill(bid.card), key: idx, label: t("bid.option", { n: idx + 1 }), onClick: function () {
                            send({ Action: { Bid: [bid.card, bid.count] } });
                        } }));
                }),
            React.createElement(Cards, { hands: props.hands, playerId: playerId, trump: trump_1 })));
    }
};
export default BidArea;
